
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/special/resident-handbook-campaign",
      function () {
        return require("private-next-pages/special/resident-handbook-campaign/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/special/resident-handbook-campaign"])
      });
    }
  